import { useState } from 'react';

interface NavbarProps {
  isFixed: boolean;
}

export default function Navbar({ isFixed }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('/#')) {
      const sectionId = href.substring(2);
      const currentPath = window.location.pathname;
      
      if (currentPath === '/' || currentPath === '') {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
          const navHeight = 64;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navHeight,
            behavior: 'smooth'
          });
        }
      }
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-2 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 rounded-xl">
              <i className="ri-heart-3-fill text-white text-xl"></i>
            </div>
            <span
              className="text-2xl font-light text-gray-800"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              다움 BEAUTY
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="/#services"
              onClick={(e) => handleNavClick(e, '/#services')}
              className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              서비스
            </a>
            <a
              href="/portfolio"
              className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              포트폴리오
            </a>
            <a
              href="/community"
              className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              커뮤니티
            </a>
            <a
              href="/#booking-guide"
              onClick={(e) => handleNavClick(e, '/#booking-guide')}
              className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              예약안내
            </a>
            <a
              href="/nearby-shops"
              className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              주변샵
            </a>
            <a
              href="/booking"
              className="px-6 py-2.5 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              예약하기
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-rose-400 transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <a
                href="/#services"
                onClick={(e) => {
                  handleNavClick(e, '/#services');
                  setIsMobileMenuOpen(false);
                }}
                className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                서비스
              </a>
              <a
                href="/portfolio"
                className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                포트폴리오
              </a>
              <a
                href="/community"
                className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                커뮤니티
              </a>
              <a
                href="/#booking-guide"
                onClick={(e) => {
                  handleNavClick(e, '/#booking-guide');
                  setIsMobileMenuOpen(false);
                }}
                className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                예약안내
              </a>
              <a
                href="/nearby-shops"
                className="text-sm text-gray-700 hover:text-rose-400 transition-colors cursor-pointer whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                주변샵
              </a>
              <a
                href="/booking"
                className="px-6 py-2.5 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg text-center cursor-pointer whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                예약하기
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
